import { Card, LiquidPill } from "components/ui/v2";
import { ExploreSideCardHeaderV2 } from "components/ui/v2/explore/ExploreSideCardHeaderV2";
import { ArrowRight } from "lucide-react";
import React, { ReactNode } from "react";

interface SideCardV2Props {
  title: string | ReactNode;
  children: ReactNode;
  loading?: boolean;
  onViewMore?: () => void;
  buttonText?: string;
  icon?: ReactNode;
  hideViewMore?: boolean;
  headerTag?: ReactNode;
  /** Compat con SideCard legacy */
  defaultExpanded?: boolean;
  /** Compat con SideCard legacy */
  collapsible?: boolean;
  /** Compat con SideCard legacy */
  variant?: "default" | "v2";
}

const SideCardV2: React.FC<SideCardV2Props> = ({
  children,
  title,
  loading = false,
  onViewMore,
  buttonText,
  icon,
  hideViewMore = false,
  headerTag,
}) => {
  return (
    <Card
      size="full"
      variant="default"
      tone="default"
      padding="none"
      shadow="subtle"
      className="w-full max-w-full"
    >
      <div className="space-y-2.5 px-4 pb-3 pt-2">
        <ExploreSideCardHeaderV2
          title={title}
          icon={icon}
          titleRight={headerTag}
          rightSlot={
            buttonText && !hideViewMore ? (
              <LiquidPill
                as="button"
                type="button"
                shape="circle"
                size="sm"
                variant="slate"
                surfaceStyle="sidebarInactive"
                icon={<ArrowRight size={14} strokeWidth={1.7} />}
                onClick={onViewMore}
                aria-label="Ver más"
                className="shrink-0"
              />
            ) : null
          }
        />

        {loading ? (
          <div className="space-y-3" role="status" aria-label="Loading widget">
            <div className="flex items-center gap-3">
              <div className="relative h-12 w-12 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
                <div className="animate-shimmer absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/10" />
              </div>
              <div className="min-w-0 flex-1 space-y-2">
                <div className="relative h-3 w-28 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
                  <div className="animate-shimmer absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/10" />
                </div>
                <div className="relative h-2.5 w-20 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
                  <div className="animate-shimmer absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/10" />
                </div>
              </div>
            </div>
            <div className="space-y-2">
              <div className="relative h-3 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
                <div className="animate-shimmer absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/10" />
              </div>
              <div className="relative h-3 w-2/3 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
                <div className="animate-shimmer absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/10" />
              </div>
            </div>
          </div>
        ) : (
          <div className="min-w-0">{children}</div>
        )}
      </div>
    </Card>
  );
};

export default SideCardV2;
